module.exports = __webpack_public_path__ + "static/images/containers/Landing/images/landing-footer-top.8457c790.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Landing/images/landing-footer-top.png
// module id = 3164
// module chunks = 11